import { Link } from "react-router-dom";

const LINKS = [
  {
    icon: "ri-fire-line",
    title: "最新影视",
    description: "按时间浏览近期上线的电影、电视剧与网剧，不错过任何一部新作。",
    to: "/category",
    action: "进入分类",
  },
  {
    icon: "ri-book-open-line",
    title: "剧情介绍",
    description: "详细梳理每部作品的剧情脉络与看点，帮你快速判断是否值得一追。",
    to: "/category?sort=rating",
    action: "高分剧情",
  },
  {
    icon: "ri-user-star-line",
    title: "演员信息",
    description: "查看演员个人简介与完整参演作品列表，从演员出发发现更多好剧。",
    to: "/search",
    action: "查找演员",
  },
];

export default function QuickLinks() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5 -mt-10 md:-mt-14 relative z-20">
        {LINKS.map((link) => (
          <Link
            key={link.title}
            to={link.to}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 transition-colors hover:border-accent-300"
          >
            <span className="flex items-center justify-center w-12 h-12 rounded-md bg-accent-100 text-accent-600 mb-4">
              <i className={`${link.icon} text-2xl`}></i>
            </span>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">{link.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{link.description}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-accent-600 group-hover:gap-2 transition-all">
              {link.action}
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}